import { Table, TableProps, Tag } from 'antd';
import { Link, createSearchParams } from 'react-router-dom';

import { InterviewScriptTemplateCollection, SerialID, StageSubTypeChoices } from '../../../types';

interface InterviewScriptTemplateFormat {
  id: SerialID;
  name: string;
  type: InterviewScriptTemplateCollection['type'];
}

interface InterviewScriptTemplateTableProps extends TableProps<InterviewScriptTemplateFormat> {
  searchParams?: URLSearchParams;
}

const InterviewScriptTemplateTable = ({
  pagination,
  searchParams,
  ...props
}: InterviewScriptTemplateTableProps) => {
  return (
    <Table<InterviewScriptTemplateFormat>
      rowKey="id"
      pagination={{
        showTotal: (total) => {
          return `Total: ${total} roteiros`;
        },
        ...pagination,
      }}
      {...props}
    >
      <Table.Column
        width="50%"
        key="name"
        title="Nome do roteiro"
        dataIndex="name"
        render={(_, record: InterviewScriptTemplateFormat) => (
          <Link
            key={`link-${record.id}`}
            className="ant-typography-link"
            to={{
              pathname: `${record.id}/change`,
              search: createSearchParams(searchParams).toString(),
            }}
          >
            {record.name}
          </Link>
        )}
      />
      <Table.Column
        width="50%"
        key="type"
        title="Tipo de entrevista"
        dataIndex="type"
        render={(_, record: InterviewScriptTemplateFormat) =>
          record.type.map((type) => (
            <Tag key={`${record.id}-${type}`}>{StageSubTypeChoices[type]}</Tag>
          ))
        }
      />
    </Table>
  );
};

export default InterviewScriptTemplateTable;
